module.exports = __webpack_public_path__ + "img/gotv.934e4716.png";